export default "__VITE_ASSET__a0c67fec__"